import React, { useState, useEffect, useRef } from "react";
import axiosConfig from "../Service/axiosConfig";
import { useNavigate } from "react-router-dom";
import { Post } from "../Components";
const PostsPage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [data, setData] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  const pageRef = useRef(1); // Persistent page tracker
  const totalPagesRef = useRef(null); // Total pages from API
  const observerRef = useRef(); // Ref for sentinel

  const endpoint = "/accounts/model-images/?is_story=false&is_active=true";

  // Fetch the first page on mount
  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    setLoading(true);
    console.log("🚀 Fetching initial posts...");
    try {
      const response = await axiosConfig.get(`${endpoint}&page=1`);
      console.log("📦 Initial Data Response:", response.data);

      const initialResults = response.data.results || [];
      setData(initialResults);

      const total = Math.ceil(response.data.count / 20);
      totalPagesRef.current = total;

      console.log(`📊 Total Pages: ${total}`);
      if (total <= 1) setHasMore(false);
    } catch (error) {
      console.error("❌ Initial Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchNextPage = async () => {
    if (loadingMore || !hasMore) {
      console.log("🛑 Already loading or no more posts");
      return;
    }

    const nextPage = pageRef.current + 1;
    console.log(`➡️ Attempting to load page: ${nextPage}`);

    setLoadingMore(true);
    try {
      const response = await axiosConfig.get(`${endpoint}&page=${nextPage}`);
      const newResults = response.data.results || [];

      console.log(`📦 Page ${nextPage} Data:`, newResults);

      if (newResults.length === 0) {
        console.log("🚫 No more posts received.");
        setHasMore(false);
        return;
      }

      setData((prev) => [...prev, ...newResults]);
      pageRef.current = nextPage;

      if (totalPagesRef.current && nextPage >= totalPagesRef.current) {
        console.log("✅ All pages loaded.");
        setHasMore(false);
      }
    } catch (error) {
      console.error("❌ Pagination Fetch Error:", error);
    } finally {
      setLoadingMore(false);
    }
  };

  // Set up IntersectionObserver for infinite scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore) {
          console.log("🔍 Nearing footer, loading more posts...");
          fetchNextPage();
        }
      },
      {
        root: null,
        rootMargin: "500px", // Trigger early
        threshold: 0,
      }
    );

    const currentObserver = observerRef.current;

    if (currentObserver) {
      observer.observe(currentObserver);
      console.log("👁️ Observer attached.");
    }

    return () => {
      if (currentObserver) {
        observer.unobserve(currentObserver);
        console.log("🧹 Observer detached.");
      }
    };
  }, [hasMore,loadingMore]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="products-container">
        {loading ? (
          <div className="loader-container">
            <img src={require("./images/loader.gif")} alt="Loading..." />
          </div>
        ) : (
          <>
            {data.length > 0 && (
              <div className="post-data">
                {data.map((itemObj, index) => (
                  <div className="post-item" key={index}>
                    <Post item={itemObj} index={index} />
                  </div>
                ))}
              </div>
            )}
          </>
        )}

        {/* Loading spinner when fetching more */}
        {loadingMore && (
          <div className="loader-container">
            <img src={require("./images/loader.gif")} alt="Loading more..." />
          </div>
        )}
        {!hasMore && (
          <div style={{ textAlign: "center", color: "#888", padding: "20px" }}>
            🎉 You’re all caught up!
          </div>
        )}

        {/* Sentinel div to trigger infinite scroll */}
        <div ref={observerRef} style={{ height: "1px" }}></div>

   
      </div>
    </div>
  );
};

export { PostsPage };
